import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import CommonHeadingNBtns from "../../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../../components-react/SelectDropdown";
import { selectGymData } from "../../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../../data/APIs";
import MultiSelect from "../../../components-react/MultiSelect";
import { fetchAllTrainersByExpLvlData } from "../../../../redux/reducers/apiSlice";
import {
  currentMonth,
  currentYearNo,
  months,
  yearsNext,
} from "../../../common-data/DropdowData";

const IncentiveTargetForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoadingFormData } = useSelector((state) => state.common);
  const { allTrainerByExpLvlData } = useSelector((state) => state.api);
  const gymData = useSelector(selectGymData);

  const forminitials = {
    isActive: isEdit && rowData.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [allTrainersData, setAllTrainerData] = useState([]);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (value, name) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const onSubmit = () => {
    // setFormErrors(validateExerciseForm(formValues));
    setIsSubmit(true);
  };

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    dispatch(
      fetchAllTrainersByExpLvlData({
        queryParameters: formValues.selectGymData?.value
          ? "gym_id=" + formValues.selectGymData.value
          : "",
        token: userInfoData?.token,
      })
    );
  }, [formValues.selectGymData]);

  useEffect(() => {
    if (allTrainerByExpLvlData?.status && allTrainerByExpLvlData?.data) {
      const trainers = allTrainerByExpLvlData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainerData(trainers);
    } else {
      setAllTrainerData([]);
    }
  }, []);

  return (
    <div className="createNewCTOModalContainer mealsModalContainer addMealModal">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Target`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoadingFormData}
      />

      <form className="formContainer">
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedGym" className={`formInputLabel `}>
              gym name <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedGym ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={gymData}
                selectedOption={formValues.selectedGym}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedGym")
                }
                name="from the list"
                preventKeyboardOpen={true}
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedTrainer" className="formInputLabel">
              Trainer name <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper no-border multi-select ${
                formErrors.selectedTrainer ? "error" : ""
              }`}
            >
              <MultiSelect
                options={allTrainersData}
                state={formValues.selectedTrainer}
                setState={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedTrainer: selectedValue,
                  }))
                }
                name="select multiple from the list"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label
              htmlFor="targetAmount"
              className={`formInputLabel ${
                formErrors?.targetAmount && "formError"
              }`}
            >
              target <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Enter target"
              className={`formInput ${
                formErrors?.targetAmount ? "formError" : ""
              }`}
              name="targetAmount"
              value={formValues.targetAmount}
              onChange={onChangeInput}
              min={0}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedYear" className={`formInputLabel `}>
              year <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedYear ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={yearsNext}
                selectedOption={formValues.selectedYear}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedYear")
                }
                name="from the list"
                preventKeyboardOpen={true}
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedMonth" className={`formInputLabel `}>
              Month <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedMonth ? "formError" : ""
              }`}
            >
              <SelectDropdown
                // options={months}
                // options={months.filter(
                //   (month) => parseInt(month.value) >= currentMonth
                // )}
                options={
                  formValues.selectedYear?.value === currentYearNo.toString()
                    ? months.filter(
                        (month) => parseInt(month.value) >= currentMonth
                      )
                    : months
                }
                selectedOption={formValues.selectedMonth}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedMonth")
                }
                name="from the list"
                preventKeyboardOpen={true}
              />
            </div>
          </div>
        </div>

        <div className="formInputsGrid switchInputs">
          <div className="formInputBox formInputSwitchBox">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isActive ? "formError" : ""
              }`}
            >
              <Form.Check
                type="switch"
                name="isActive"
                label={`${formValues.isActive ? "Active" : "Not Active"}`}
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default IncentiveTargetForm;
